// 📁 hooks/useVoucherInfo.ts
import { useState } from 'react'
import type { HotelVoucherAvailabilityParams } from '~/hooks/type'
import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'

export function useVoucherInfo() {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<any>(null)
  const [error, setError] = useState<any>(null)

  const verifyOrder = async (params: HotelVoucherAvailabilityParams) => {
    setLoading(true)
    setError(null)

    try {
      const res = await fetch(`${process.env.NEXT_PUBLIC_BEV_URL}/evoucher/check`, {
        method: 'POST', // ✅ use POST if sending JSON
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          Accept: 'application/json',
        },
        body: JSON.stringify(params),
      })

      if (!res['isSuccess']) {
        setError(res['errors'])
      } else if (res['status'] === 429) {
        setError([
          {
            id: null,
            code: '429',
            message: t('voucher_detail.error.too_many_requests'),
          },
        ])
      } else {
        setError(null)
      }
      console.log(res)

      const data = await res.json()
      setResponse(data)
      return data
    } catch (err) {
      setError(err)
      console.error('Error verifying order:', err)
    } finally {
      setLoading(false)
    }
  }

  return { verifyOrder, loading, response, error }
}
